import React, { FC } from 'react'
import { HighlightedMarkup } from 'transfix-ui/components/AutocompleteBase/components/AutocompleteOption/HighlightedMarkup'
import { getMatchedCNString } from './getMachedCNString'

interface IBoldSubjectProps {
  /**
   * @example "/C=US/ST=Iowa/L=Des Moines/O=Ruan Transportation Management Systems Inc/CN=*.ruan.com"
   */
  subject: string | null
}

export const BoldSubject: FC<IBoldSubjectProps> = ({ subject }) => {
  if (!subject) {
    return null
  }

  const strToBeBold = getMatchedCNString(subject)
  if (!strToBeBold) {
    return <span>{subject}</span>
  }

  return <HighlightedMarkup suggestion={subject} value={strToBeBold} />
}
